import { Component } from 'react';

import { Box, Stack } from '@mui/material';

import ProjectImage from './ProjectImage';
import ProjectTitle from './ProjectTitle';
import ProjectDescription from './ProjectDescription';
import ProjectFooter from './ProjectFooter';

export default class ProjectCard extends Component {
  constructor(props) {
    super(props);

    const item = props.item;
    this.state = {
      item
    }
  }
  
  render() {
    const {
      item
    } = this.state;

    return (
      <Stack className='card' sx={{ justifyContent: 'space-between', justifyItems: 'center', width: '100%' }} >
        <Box><ProjectImage       item={item} /></Box>
        <Box><ProjectTitle       item={item} /></Box>
        <Box><ProjectDescription item={item} /></Box>
        <Box><ProjectFooter      item={item} /></Box>
      </Stack>
    );
  }
}
